var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.collectionLoaded)?_c('CollectionsCarouselList',{attrs:{"collections":_vm.allCollections}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }